import { gql } from "@apollo/client";

const FETCH_INSTANCE_LOGISTICS_JOBS = gql`
  query FetchInstanceLogisticsJobs($input: AdvJobFilterInput!) {
    jobsV2(input: $input) {
      count
      edges {
        id
        description
        dueDate
        duetime
        statusId
        jobStatus {
          description
        }
        jobType {
          description
        }
        jobItems {
          instanceId
        }
      }
    }
  }
`;

const FETCH_INSTANCE_LOGISTICS_EXHIBITIONS = gql`
  query FetchInstanceLogisticsExhibitions($input: AdvExhibitionFilterInput!) {
    exhibitionsV2(input: $input) {
      edges {
        id
        title
        type
        startDate
        endDate
        exhibitionWorks {
          instanceId
          removed
        }
      }
    }
  }
`;

const FETCH_INSTANCE_LOGISTICS_RESERVATIONS = gql`
  query FetchInstanceLogisticsReservations(
    $input: AdvReservationInstancesFilterInput!
  ) {
    reservationInstancesV2(input: $input) {
      edges {
        id
        instanceId
        released
        reservation {
          categoryId
          date
          dateDue
          description
          id
          reservationUser {
            name
          }
          type {
            description
          }
        }
      }
    }
  }
`;

export {
  FETCH_INSTANCE_LOGISTICS_EXHIBITIONS,
  FETCH_INSTANCE_LOGISTICS_JOBS,
  FETCH_INSTANCE_LOGISTICS_RESERVATIONS,
};
